import { IBaseIconProps } from "./IBaseIconProps";

/**
 * Four rounded squares: a group of more pages ("Администрация" → "Други"). The viewBox leaves
 * room around them, so in the menu's 34px box the grid looks as big as its neighbours' glyphs
 * and the label lines up with theirs.
 */
export const AppsIcon = ({ color = "currentColor" }: IBaseIconProps) => {
  return (
    <svg width="24" height="24" viewBox="-5 -5 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="8" height="8" rx="2" fill={color} />
      <rect x="13" y="3" width="8" height="8" rx="2" fill={color} />
      <rect x="3" y="13" width="8" height="8" rx="2" fill={color} />
      <rect x="13" y="13" width="8" height="8" rx="2" fill={color} />
    </svg>
  );
};
